import { isAllowRefresh } from '@/utils/util'
let _self
export const index = {
  props: {
    isShow: { type: Boolean, required: true, default: false },
    checkeds: { type: Array, required: true },
    checkedDeps: { type: Array, required: true },
    isMultiple: { type: Boolean, default: true },
    title: { type: Boolean }
  },
  data() {
    return {
      showBox: false,
      count: 20,
      searchName: '',
      department: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      tableData: [],
      userSelection: [],
      defaultProps: { children: 'children', label: 'label', value: 'value', isLeaf: 'isHasChildren' },
      filterText: '',
      isAllowRefresh: isAllowRefresh(),
      treeData01: [],
      treeData02: [],
      checkedEmployee: [],
      checkedDepartment: [],
      resolve_had: '',
      disabled: true,
      shopShow: false,
      isShowGaoliang: false,
      peoples: [],
      deps: [],
      titles: '选择员工',
      orderCheckeds: {},
      orderCheckedDeps: {},
      showList: [],
      nodeLock: false
    }
  },
  mounted() {
    _self = this
  },
  watch: {
    isShow: function(newVal, oldVal) {
      this.showBox = newVal
      if (newVal) {
        // this.checkedEmployee = []
        this.initData()
      }
    },
    treeData01: function(newVal) {
    },
    treeData02: function(newVal) {
      if (newVal.length > 0) {
        this.shopShow = true
      } else {
        this.shopShow = false
      }
    },
    checkedEmployees(val) {
      if (val.length > 0) {
        this.checkedEmployee = val
      }
    },
    checkedEmployee(val) {
      if (val.length > 0 || this.checkedDepartment.length > 0) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      this.checkSelectList()
    },
    checkedDepartment(val) {
      if (val.length > 0 || this.checkedEmployee.length > 0) {
        this.disabled = false
      } else {
        this.disabled = true
      }
      this.checkSelectList()
    },
    filterText(val) {
      if (val) {
        this.$refs.tree.filter(val)
      } else {
        this.treeData01 = []
        this.sfhusi()
      }
    }
  },
  methods: {
    initData() {
      console.log('initData')
      this.parent_id = 0
      this.peoples = []
      if (this.title) this.titles = '添加员工'
      if (this.checkeds || this.checkeds.length > 0) {
        this.checkeds.forEach(k => {
          this.peoples.push(k.id)
        })
        this.checkedEmployee = Object.assign([], this.checkeds)
      }
      if (this.checkedDeps || this.checkedDeps.length > 0) {
        this.checkedDeps.forEach(k => {
          this.peoples.push(k.id)
        })
        this.checkedDepartment = Object.assign([], this.checkedDeps)
      }
      console.log(this.peoples)
      this.treeData01 = []
      this.sfhusi()
    },
    currentChange(val) {
      this.currentPage = val
    },
    // 获取组织架构
    async loadNode(node, resolve) {
      if (node === undefined || node.level === 0) {
        this.chooseNode = node
        resolve(this.treeData01)
      } else {
        this.parent_id = node.data.value
        this.$api.post('/api/v1/test/get-department', {
          user_id: sessionStorage.getItem('user_id'),
          parent_id: this.parent_id
        }).then(res => {
          if (res.return_data.length === 0) {
            this.treeData01 = res.return_data
          } else {
            for ( var index in res.return_data) {
              var item = res.return_data[index]
              if (item.is_show) res.return_data[index].disabled = true
            }
            this.chooseNode = 0
            this.treeData01 = res.return_data
            resolve(this.treeData01)
          }
        })
      }
    },
    // 一级
    sfhusi() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        this.chooseNode = 0
        if (res.return_data && res.return_data.length > 0) {
          for ( var index in res.return_data) {
            var item = res.return_data[index]
            if (item.is_show) res.return_data[index].disabled = true
          }
          this.treeData01 = res.return_data
        }
      })
    },
    // 二级
    getChildrenNode() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        if (res.return_data.length === 0) {
          this.treeData01 = res.return_data
        } else {
          for ( var index in res.return_data) {
            var item = res.return_data[index]
            if (item.is_show) res.return_data[index].disabled = true
          }
          this.chooseNode = 0
          this.treeData01 = res.return_data
        }
      })
    },
    // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    reset() {
      this.currentPage = 1
      this.searchName = ''
      this.departmentId = ''
    },
    getChecked(value, isCheck) {
      if (!value.label) {
        return false
      }
      if (value.isDepartment === true) {
        var checkedEmployee = this.checkedEmployee
        if (isCheck === false) {
          checkedEmployee.forEach((item, i) => {
            if (item.id === value.value) {
              checkedEmployee.splice(i, 1)
            }
          })
        } else {
          var hasData = false
          for (var key in checkedEmployee) {
            if (checkedEmployee[key].id === value.value) hasData = true
          }
          if (!hasData) {
            if (value.department_name) {
              // checkedEmployee = []
              checkedEmployee.push({
                id: value.value,
                name: value.label,
                show: 'false'
              })
            } else {
              // checkedEmployee = []
              checkedEmployee.push({
                id: value.value,
                name: value.label
              })
              // this.$refs.tree.setCheckedKeys([])
              // this.$refs.tree.setCheckedKeys([value.value])
            }
          }

          this.checkedEmployee = checkedEmployee
        }
      } else {
        var checkedDepartment = this.checkedDepartment
        if (isCheck === false) {
          checkedDepartment.forEach((item, i) => {
            if (item.id === value.value) checkedDepartment.splice(i, 1)
          })
        } else {
          // checkedDepartment = []
          checkedDepartment.push({
            id: value.value,
            name: value.label
          })
          // this.$refs.tree.setCheckedKeys([])
          // this.$refs.tree.setCheckedKeys([value.value])
          this.checkedDepartment = checkedDepartment
        }
        this.$refs.tree.setChecked(value.id, false)
        return false
      }
    },
    employeeClose(value, index) {
      var checkedKeys = []
      if (this.$refs.tree) {
        checkedKeys = this.$refs.tree.getCheckedKeys()
      }
      var employeeKey = 0
      for (var key in this.checkedEmployee) {
        if (this.checkedEmployee[key].id === value.id) {
          employeeKey = key
          break
        }
      }
      if (checkedKeys.indexOf(value.id) === -1) {
        this.checkedEmployee.splice(employeeKey, 1)
      }
      if (this.peoples.indexOf(value.id) > -1) {
        this.peoples.splice(this.peoples.indexOf(value.id), 1)
      }
      if (this.$refs.tree) {
        this.$refs.tree.setChecked(value.id, false)
      }
    },
    departmentClose(value, index) {
      var checkedKeys = []
      if (this.$refs.tree) {
        checkedKeys = this.$refs.tree.getCheckedKeys()
      }

      var departmentKey = 0
      for (var key in this.checkedDepartment) {
        if (this.checkedDepartment[key].id === value.id) {
          departmentKey = key
          break
        }
      }

      if (checkedKeys.indexOf(value.id) === -1) {
        this.checkedDepartment.splice(departmentKey, 1)
      }
      if (this.peoples.indexOf(value.id) > -1) {
        this.peoples.splice(this.peoples.indexOf(value.id), 1)
      }
      if (this.$refs.tree) {
        this.$refs.tree.setChecked(value.id, false)
      }
    },
    selectConfirm() {
      this.$emit('check-user', this.checkedEmployee)
      this.$emit('check-dep', this.checkedDepartment)
    },
    dfhuh() {
      this.$api.post('/api/v1/test/get-user-department', {
        user_id: sessionStorage.getItem('user_id'),
        name: this.filterText
      })
      .then(res => {
        if (res.length === 0 || res.user_data.length === 0) {
          this.treeData02 = []
          this.parent_id = 0
          this.sfhusi()
          // this.loadNode()
        } else {
          this.treeData02 = res.user_data
        }
      })
    },
    close() {
      this.showBox = false
      this.checkedEmployee = []
      this.checkedDepartment = []
      this.$emit('update:isShow', false)
    },
    clear() {
       this.filterText = ''
       this.treeData02 = []
       this.treeData01 = []
       // this.checkedEmployee = []
       // this.checkedDepartment = []
       this.parent_id = 0
       this.sfhusi()
    },
    checkSelectList() {
       this.showList = []
      var that = this
      for (var index in this.checkedEmployee) {
        var hasEmployee = 0
        for (var key in this.showList) {
          if (this.showList[key].name === this.checkedEmployee[index].name) hasEmployee = 1
        }

        if ( !hasEmployee ) {
          var itemEmployee = Object.assign([], this.checkedEmployee[index])
          itemEmployee.type = 'employee'
          this.showList.push(itemEmployee)
        }
      }
      for (var index1 in this.checkedDepartment) {
        var hasDepart = 0
        for (var key1 in this.showList) {
          if (this.showList[key1].name === this.checkedDepartment[index1].name) hasDepart = 1
        }

        if ( !hasDepart ) {
          var itemDepart = Object.assign([], this.checkedDepartment[index1])
          itemDepart.type = 'depart'
          this.showList.push(itemDepart)
        }
      }

      for (var index2 in this.showList) {
        if ( this.showList[index2].type === 'employee' ) {
          var hasEmployee1 = 0
          for (var key2 in this.checkedEmployee) {
            if ( this.showList[index2].name === this.checkedEmployee[key2].name) {
              hasEmployee1 = 1
            }
          }
          if ( !hasEmployee1 ) {
             this.showList.splice(index2, 1)
          }
        }
      }
      for (var index3 in this.showList) {
        if ( this.showList[index3].type === 'depart' ) {
            var hasDepart1 = 0
            for (var key3 in this.checkedDepartment) {
              if (this.showList[index3].name === this.checkedDepartment[key3].name) hasDepart1 = 1
            }
            if ( !hasDepart1 ) {
               this.showList.splice(index3, 1)
            }
        }
      }

      // console.log(this.checkedDepartment)
    },

    showListClose(item, index, type) {
      if ( type === 'employee' ) {
        this.employeeClose(item, index)
      } else if ( type === 'depart' ) {
        this.departmentClose(item, index)
      }
    }

  }
}
